import { useContext } from 'react';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import useIsReservableVehicle from '~/hooks/vdp/selectors/useIsReservableVehicle';

export default function useHasVehicleNotifyStatus() {
  const { shouldShowTimer } = useContext(UnlockTimerContext);
  const { purchasePending } = useAlertStatus();
  const isReservable = useIsReservableVehicle();

  return purchasePending || shouldShowTimer || isReservable;
}
